import React from 'react';
import { Box, Typography, TextField, FormControlLabel, Switch, IconButton } from '@mui/material';
import { DragHandle, Audiotrack } from '@mui/icons-material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableSeriesItem = ({ id, label, seriesDay, isDarkMode, onDataChange }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    backgroundColor: isDragging ? 'rgb(235, 235, 235)' : undefined,
    zIndex: isDragging ? 1 : undefined,
  };

  const handleDayChange = (e) => {
    const value = e.target.value;
    onDataChange(id, {
      series_day: value === '' ? 0 : parseInt(value, 10),
      session_is_dark_mode: isDarkMode ? 1 : 0
    });
  };

  const handleDarkModeChange = (e) => {
    onDataChange(id, {
      series_day: seriesDay,
      session_is_dark_mode: e.target.checked ? 1 : 0
    });
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: 1,
        px: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        '&:last-child': {
          borderBottom: 'none'
        },
        '&:hover': {
          bgcolor: 'action.hover'
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
        <Audiotrack sx={{ mr: 1, color: 'text.secondary', fontSize: '1.1rem' }} />
        <Typography
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '0.875rem'
          }}
        >
          {label}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <TextField
          type="number"
          size="small"
          label="Day"
          value={seriesDay || ''}
          onChange={handleDayChange}
          sx={{
            width: '80px',
            '& .MuiInputBase-root': {
              height: '36px'
            }
          }}
          slotProps={{ input: { min: 0 } }}
        />

        <FormControlLabel
          control={
            <Switch
              checked={isDarkMode}
              onChange={handleDarkModeChange}
              size="small"
            />
          }
          label={<Typography sx={{ fontSize: '0.875rem' }}>Dark Mode</Typography>}
          sx={{ mr: 1 }}
        />

        <IconButton
          size="small"
          sx={{
            cursor: 'grab',
            '&:active': { cursor: 'grabbing' },
            color: 'text.secondary'
          }}
          {...attributes}
          {...listeners}
        >
          <DragHandle />
        </IconButton>
      </Box>
    </Box>
  );
};

export default SortableSeriesItem; 